import _ from "lodash";
import { DateTime } from "luxon";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import {
  StyleTypeContext,
  TranslationContext,
  handleNonValidImgFn,
} from "../../../umbilical_tools";
import PropTypes from "prop-types";
import jssVariables from "../../../jss_setup";
import { useSelector } from "react-redux";
import { InlineIcon } from "@iconify/react";
import { PlaceholderPrebook } from "./components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Price } from "../../common/Price";
import { Inclusions } from "../../../pages/CarRentals/CarRental/helpers";
import { CustomCheckbox } from "../../forms/inputGroup/helpers";

function workingHoursStyles() {
  return {
    backgroundColor: "lightgray",
    color: jssVariables.colors.text.dark,
    borderRadius: jssVariables.half_gap,
    boxShadow: jssVariables.shadows.normalShadow,
  };
}

function locationTooltipStyles() {
  return {
    ...workingHoursStyles(),
    width: "20rem",
    fontSize: "large",
  };
}

const styles = createUseStyles({
  Prebook: (props) => ({
    width: "80vw",
    ..._.get(props, "customStyles.Prebook", {}),
  }),
  header: (props) => ({
    paddingBottom: jssVariables.double_gap,
    ..._.get(props, "customStyles.header", {}),
  }),
  carName: (props) => ({
    fontSize: "x-large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.carName", {}),
  }),
  imgContr: (props) => ({
    padding: jssVariables.double_gap,
    ..._.get(props, "customStyles.imgContr", {}),
  }),
  img: (props) => ({
    height: "100%",
    width: "100%",
    objectFit: "contain",
    ..._.get(props, "customStyles.carName", {}),
  }),
  items: (props) => ({
    display: "grid",
    gridGap: jssVariables.double_gap,
    ..._.get(props, "customStyles.items", {}),
  }),
  itemsCol: (props) => ({
    ..._.get(props, "customStyles.itemsCol", {}),
  }),
  item: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr max-content",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    fontSize: "large",
    padding: [jssVariables.half_gap, 0],
    width: "80vw",
    ..._.get(props, "customStyles.item", {}),
  }),
  itemIcon: (props) => ({
    fontSize: "x-large",
    color: jssVariables.colors.base_color,
    ..._.get(props, "customStyles.itemIcon", {}),
  }),
  meetingPoints: (props) => ({
    display: "grid",
    gridGap: jssVariables.double_gap,
    fontSize: "medium",
    ..._.get(props, "customStyles.meetingPoints", {}),
  }),
  meetingPoint: (props) => ({
    display: "grid",
    gridGap: jssVariables.half_gap,
    width: "70vw",
    alignContent: "start",
    alignItems: "start",
    ..._.get(props, "customStyles.meetingPoint", {}),
  }),
  meetPointType: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.meetPointType", {}),
  }),
  meetPointLocation: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: jssVariables.half_gap,
    padding: [jssVariables.half_gap, 0],
    width: "80vw",
    ..._.get(props, "meetPointLocation.pickUpIcon", {}),
  }),
  meetPointLocationText: (props) => ({
    width: "100%",
    fontSize: "large",
    textTransform: "capitalize",
    ..._.get(props, "meetPointLocation.meetPointLocationText", {}),
  }),
  meetPointIcon: (props) => ({
    color: jssVariables.colors.base_color,
    fontSize: "x-large",
    gridRow: "1 / span 2",
    ..._.get(props, "customStyles.meetPointIcon", {}),
  }),
  infoIcon: (props) => ({
    color: jssVariables.colors.base_color,
    ..._.get(props, "customStyles.infoIcon", {}),
  }),
  workingDays: (props) => ({
    display: "grid",
    gridTemplateColumns: "repeat(4, max-content)",
    gridGap: `0 ${jssVariables.normal_gap}`,
    ..._.get(props, "customStyles.workingDays", {}),
  }),
  vehicleSpecsNum: (props) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, max-content)",
    gridGap: jssVariables.double_gap,
    fontSize: "x-large",
    justifyContent: "left",
    color: jssVariables.colors.base_color,
    padding: `calc(${jssVariables.normal_gap} * 2.5) 0`,
    paddingLeft: jssVariables.half_gap,
    ..._.get(props, "customStyles.vehicleSpecsNum", {}),
  }),
  priceContr: (props) => ({
    display: "grid",
    color: jssVariables.colors.base_color,
    textAlign: "right",
    justifyItems: "baseline",
    justifySelf: "baseline",
    padding: `calc(${jssVariables.normal_gap} * 2) 0`,
    ..._.get(props, "customStyles.priceContr", {}),
  }),
  totalPrice: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    justifyContent: "space-between",
    width: "17rem",
    fontSize: "x-large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.totalPrice", {}),
  }),
  priceItem: (props) => ({
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    gridGap: jssVariables.half_gap,
    alignItems: "end",
    justifyContent: "space-between",
    justifyItems: "left",
    width: "17rem",
    fontSize: "medium",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.priceItem", {}),
  }),
  priceLabel: (props) => ({
    textAlign: "left",
    ..._.get(props, "customStyles.priceLabel", {}),
  }),
  extraInfoFees: (props) => ({
    position: "relative",
    borderRadius: `calc(${jssVariables.normal_gap} / 1.3)`,
    padding: jssVariables.half_gap,
    paddingLeft: jssVariables.normal_gap,
    paddingTop: jssVariables.normal_gap,
    "& > ul": {
      paddingLeft: jssVariables.double_gap,
      width: "85%",
    },
    marginTop: jssVariables.double_gap,
    background: "#F2F2F2",
    ..._.get(props, "customStyles.extraInfoFees", {}),
  }),
  extraInfo: (props) => ({
    position: "relative",
    border: `1px solid ${jssVariables.colors.base_color}`,
    borderRadius: `calc(${jssVariables.normal_gap} / 1.3)`,
    padding: jssVariables.half_gap,
    paddingLeft: jssVariables.normal_gap,
    paddingTop: jssVariables.normal_gap,
    "& > ul": {
      paddingLeft: jssVariables.double_gap,
      width: "85%",
    },
    marginTop: jssVariables.double_gap,
    ..._.get(props, "customStyles.extraInfo", {}),
  }),
  extraInfoIcon: (props) => ({
    position: "absolute",
    top: jssVariables.half_gap,
    right: jssVariables.half_gap,
    color: jssVariables.colors.base_color,
    fontSize: "x-large",
    ..._.get(props, "customStyles.extraInfoIcon", {}),
  }),
  providerContr: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content 1fr max-content",
    gridGap: jssVariables.half_gap,
    alignItems: "center",
    textTransform: "capitalize",
    ..._.get(props, "customStyles.providerContr", {}),
  }),
  providerLogo: (props) => ({
    height: "3rem",
    maxWidth: "7rem",
    objectFit: "contain",
    ..._.get(props, "customStyles.providerLogo", {}),
  }),
  anchorLink: (props) => ({
    color: jssVariables.colors.base_color,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "none",
      color: "gray",
    },
    "&:visited": {
      textDecoration: "none",
      color: jssVariables.colors.base_color,
    },
    ..._.get(props, "customStyles.anchorLink", {}),
  }),
  divider: (props) => ({
    width: "100%",
    margin: [jssVariables.half_gap, 0],
    ..._.get(props, "customStyles.divider", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    Prebook: (props) => ({
      width: "100%",
      ..._.get(props, "customStyles.Prebook.smallscreen", {}),
    }),
    header: (props) => ({
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gridGap: jssVariables.double_gap,
      ..._.get(props, "customStyles.header.smallscreen", {}),
    }),
    img: (props) => ({
      width: "10rem",
      ..._.get(props, "customStyles.carName.smallscreen", {}),
    }),
    meetingPoints: (props) => ({
      gridTemplateColumns: "1fr 1fr",
      ..._.get(props, "customStyles.meetingPoints.smallscreen", {}),
    }),
    meetingPoint: (props) => ({
      width: "100%",
      ..._.get(props, "customStyles.meetingPoint.", {}),
    }),
    meetPointLocation: (props) => ({
      width: "100%",
      ..._.get(props, "meetPointLocation.pickUpIcon.smallscreen", {}),
    }),
    vehicleSpecsNum: (props) => ({
      padding: [jssVariables.double_gap, 0],
      paddingTop: `calc(${jssVariables.normal_gap} * 2.5)`,
      ..._.get(props, "customStyles.vehicleSpecsNum.smallscreen", {}),
    }),
    items: (props) => ({
      gridTemplateColumns: "1fr 1fr",
      ..._.get(props, "customStyles.items.smallscreen", {}),
    }),
    itemsCol: (props) => ({
      "&:first-child": {
        paddingTop: "2rem",
      },
      ..._.get(props, "customStyles.itemsCol.smallscreen", {}),
    }),
    item: (props) => ({
      width: "100%",
      ..._.get(props, "customStyles.item.smallscreen", {}),
    }),
    providerContr: (props) => ({
      gridTemplateColumns: "max-content max-content 1fr 50%",
      gridGap: jssVariables.half_gap,
      alignItems: "center",
      ..._.get(props, "customStyles.providerContr", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
const Prebook = ({ loading, preBookResult, agreed, setAgreed }) => {
  const { t } = useContext(TranslationContext);
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({
    type,
    brand,
    objName: "CarPreBook",
  });
  const classes = styles({ customStyles });

  const { searchForm } = useSelector((state) => {
    return {
      searchForm: state.CarRentalSearchForm,
    };
  });

  const extraInfo = _.get(preBookResult, "inclusions", []).filter(
    (incl) =>
      ["Cancellation fee"].includes(incl.coverage_type) && incl.description
  );

  return (
    <div className={classes.Prebook}>
      {loading || _.isEmpty(preBookResult) ? (
        <PlaceholderPrebook />
      ) : (
        <React.Fragment>
          <div className={classes.header}>
            <div className={classes.headerCol}>
              <div className={classes.carName}>
                {preBookResult?.vehicle?.name}
              </div>
              <div className={classes.imgContr}>
                <img
                  src={_.get(preBookResult, "vehicle.image", "")}
                  alt=""
                  className={classes.img}
                />
              </div>
            </div>
            <div className={classes.headerCol}>
              <div className={classes.priceContr}>
                <div className={classes.totalPrice}>
                  <span className={classes.priceLabel}>
                    {" "}
                    {t("totalPrice")}:{" "}
                  </span>
                  <Price
                    price={preBookResult?.price?.amount ?? 0}
                    currency={preBookResult?.price?.currency}
                    styleless
                  />
                </div>
                <div
                  className={classes.priceItem}
                  style={{ paddingTop: jssVariables.half_gap }}>
                  <strong className={classes.priceLabel}>
                    {t("dueNow")}:{" "}
                  </strong>
                  <strong>
                    <Price
                      price={preBookResult?.price_breakdown.pay_now.amount ?? 0}
                      currency={
                        preBookResult?.price_breakdown?.pay_now?.currency
                      }
                      styleless
                    />
                  </strong>
                </div>
                <div className={classes.priceItem}>
                  <span className={classes.priceLabel}>
                    {t("carRentalRate")}:{" "}
                  </span>
                  <Price
                    price={preBookResult?.price_breakdown?.pay_now?.amount ?? 0}
                    currency={preBookResult?.price_breakdown?.pay_now?.currency}
                    styleless
                  />
                </div>
                {(preBookResult?.price_breakdown?.pay_on_pickup_total?.amount ??
                  0) > 0 && (
                  <div
                    className={classes.priceItem}
                    style={{ paddingTop: jssVariables.half_gap }}>
                    <strong className={classes.priceLabel}>
                      {t("duePickUp")}:{" "}
                    </strong>
                    <strong>
                      <Price
                        price={
                          preBookResult?.price_breakdown?.pay_on_pickup_total
                            ?.amount ?? 0
                        }
                        currency={
                          preBookResult?.price_breakdown?.pay_on_pickup_total
                            ?.currency
                        }
                        styleless
                      />
                    </strong>
                  </div>
                )}
                {(
                  preBookResult?.price_breakdown?.pay_on_pickup_charges ?? []
                ).map((item, idx) => (
                  <div className={classes.priceItem} key={idx}>
                    <span className={classes.priceLabel}>
                      {item.coverage_type}:{" "}
                    </span>
                    <Price
                      price={item.amount}
                      currency={item.currency}
                      styleless
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.item}>
              <div className={classes.providerContr}>
                <InlineIcon
                  icon="tabler:building"
                  className={classes.itemIcon}
                />
                {`${t("provider")}: ${preBookResult?.supplier?.name ?? "-"}`}
                <div />
              </div>
              <img
                className={classes.providerLogo}
                alt=""
                src={_.get(preBookResult, "supplier_logo", "")}
                onError={handleNonValidImgFn}
              />
            </div>
          </div>
          <div className={classes.meetingPoints}>
            <div className={classes.meetingPoint}>
              <div className={classes.meetPointType}>{t("pickUp")}:</div>
              <div className={classes.meetPointDate}>
                {DateTime.fromISO(
                  preBookResult?.pickup_datetime
                ).toLocaleString(DateTime.DATETIME_MED)}
              </div>
              <div className={classes.meetPointLocation}>
                <InlineIcon
                  icon="material-symbols:distance"
                  className={classes.meetPointIcon}
                />
                <div
                  className={`${classes.meetPointLocationText} pick_up_point_meta_label`}>
                  {searchForm?.pick_up_point?.pick_up_point_meta?.label}
                </div>
                <ReactTooltip
                  anchorSelect=".pick_up_point_meta_label"
                  place="top"
                  style={{ ...locationTooltipStyles() }}>
                  {searchForm?.pick_up_point?.pick_up_point_meta?.label}
                </ReactTooltip>
                <small
                  className={`${classes.meetPointLocationText} pick_up_point_address`}>
                  {_.capitalize(preBookResult?.pickup_location?.full_address)}
                </small>
                <div />
                <hr className={classes.divider} />
                <div />
                <small
                  className={`${classes.meetPointLocationText} pick_up_point_address`}>
                  {_.capitalize(preBookResult?.pickup_location?.more_info)}
                </small>
                <ReactTooltip
                  anchorSelect=".pick_up_point_address"
                  place="top"
                  style={{ ...locationTooltipStyles() }}>
                  {preBookResult?.pickup_location?.full_address}
                </ReactTooltip>
              </div>
              <div className={classes.item}>
                <InlineIcon
                  className={classes.itemIcon}
                  icon="ic:baseline-local-phone"
                />
                {_.get(
                  preBookResult,
                  "pickup_location.phones.0.phone",
                  "N/A"
                ) || "N/A"}
              </div>
              <div className={classes.item}>
                <InlineIcon
                  icon="ic:baseline-calendar-month"
                  className={classes.itemIcon}
                />
                {t("workingHours")}
                <InlineIcon
                  icon="ic:baseline-info"
                  className={`${classes.infoIcon} pick_up_working_hours`}
                />
                <ReactTooltip
                  anchorSelect=".pick_up_working_hours"
                  place="bottom"
                  className={classes.workingDaysTooltip}
                  style={{
                    ...workingHoursStyles(),
                  }}>
                  <div className={classes.workingDays}>
                    {preBookResult?.pickup_location?.working_days
                      .filter((day) => day.is_open)
                      .map((day, idx) => (
                        <React.Fragment key={idx}>
                          <div>{day.day}</div>
                          <div>{day.start_hour}</div>
                          {" - "}
                          <div>{day.end_hour}</div>
                        </React.Fragment>
                      ))}
                  </div>
                </ReactTooltip>
              </div>
            </div>
            {/* ----- */}
            <div className={classes.meetingPoint}>
              <div className={classes.meetPointType}>{t("dropOff")}:</div>
              <div className={classes.meetPointDate}>
                {DateTime.fromISO(
                  preBookResult.dropoff_datetime
                ).toLocaleString(DateTime.DATETIME_MED)}
              </div>
              <div className={classes.meetPointLocation}>
                <InlineIcon
                  icon="material-symbols:distance"
                  className={classes.meetPointIcon}
                />
                <div
                  className={`${classes.meetPointLocationText} drop_off_point_meta_label`}>
                  {searchForm?.drop_off_point?.drop_off_point_meta?.label}
                </div>
                <ReactTooltip
                  anchorSelect=".drop_off_point_meta_label"
                  place="top"
                  style={{ ...locationTooltipStyles() }}>
                  {searchForm?.drop_off_point?.drop_off_point_meta?.label}
                </ReactTooltip>
                <small
                  className={`${classes.meetPointLocationText} drop_off_point_address`}>
                  {_.capitalize(preBookResult?.dropoff_location?.full_address)}
                </small>
                <div />
                <hr className={classes.divider} />
                <div />
                <small
                  className={`${classes.meetPointLocationText} drop_off_point_address`}>
                  {_.capitalize(preBookResult?.dropoff_location?.more_info)}
                </small>
                <ReactTooltip
                  anchorSelect=".drop_off_point_address"
                  place="top"
                  style={{ ...locationTooltipStyles() }}>
                  {preBookResult?.dropoff_location?.full_address}
                </ReactTooltip>
              </div>
              <div className={classes.item}>
                <InlineIcon
                  className={classes.itemIcon}
                  icon="ic:baseline-local-phone"
                />
                {_.get(
                  preBookResult,
                  "dropoff_location.phones.0.phone",
                  "N/A"
                ) || "N/A"}
              </div>
              <div className={classes.item}>
                <InlineIcon
                  icon="ic:baseline-calendar-month"
                  className={classes.itemIcon}
                />
                {t("workingHours")}
                <InlineIcon
                  icon="ic:baseline-info"
                  className={`${classes.infoIcon} drop_off_working_hours`}
                />
                <ReactTooltip
                  anchorSelect=".drop_off_working_hours"
                  place="bottom"
                  className={classes.workingDaysTooltip}
                  style={{
                    ...workingHoursStyles(),
                  }}>
                  <div className={classes.workingDays}>
                    {preBookResult?.dropoff_location?.working_days.map(
                      (day, idx) => (
                        <React.Fragment key={idx}>
                          <div>{day.day}</div>
                          <div>{day.start_hour}</div>
                          {" - "}
                          <div>{day.end_hour}</div>
                        </React.Fragment>
                      )
                    )}
                  </div>
                </ReactTooltip>
              </div>
            </div>
          </div>
          <div className={classes.vehicleSpecsNum}>
            <span>
              {_.get(preBookResult, "vehicle.passenger_quantity", 0)}{" "}
              <InlineIcon
                icon="ic:baseline-person"
                className={classes.vehicleSpecsIcon}
              />
            </span>
            <span>
              {_.get(preBookResult, "vehicle.baggage_quantity", 0)}{" "}
              <InlineIcon
                icon="material-symbols:luggage"
                className={classes.vehicleSpecs}
              />
            </span>
            <span>
              {_.get(preBookResult, "vehicle.door_count", 0)}{" "}
              <InlineIcon
                icon="mdi:car-door"
                className={classes.vehicleSpecs}
              />
            </span>
          </div>
          <div className={classes.items}>
            <div className={classes.itemsCol}>
              <div className={classes.item}>
                <InlineIcon
                  icon="mdi:car-shift-pattern"
                  className={classes.itemIcon}
                />
                {`${t("transmission")}: ${_.get(
                  preBookResult,
                  "vehicle.transmission_type",
                  "-"
                )}`}
              </div>
              <div className={classes.item}>
                <InlineIcon
                  icon="material-symbols:mode-fan"
                  className={classes.itemIcon}
                />
                {`${t("airCondition")}: ${
                  _.get(preBookResult, "vehicle.has_air_condition", false)
                    ? t("yes")
                    : t("no")
                }`}
              </div>
              <div className={classes.item}>
                <InlineIcon
                  icon="ic:baseline-person-outline"
                  className={classes.itemIcon}
                />
                {`${t("minimumAge")}: ${_.get(
                  preBookResult,
                  "minimum_age",
                  "-"
                )}`}
              </div>
              <div className={classes.item}>
                <InlineIcon
                  icon="ic:baseline-person"
                  className={classes.itemIcon}
                />
                {`${t("maximumAge")}: ${_.get(
                  preBookResult,
                  "maximum_age",
                  "-"
                )}`}
              </div>
            </div>
            <div className={classes.itemsCol}>
              <Inclusions carRental={preBookResult} />
            </div>
          </div>
          <div className={classes.extraInfoFees}>
            <h5>Fees & Protection</h5>
            <ul>
              {preBookResult?.inclusions
                .filter((incl) => ["SLI", "CDW", "TP"].includes(incl.code))
                .map((incl, idx) => (
                  <li key={idx}>
                    <span>{incl.coverage_type}</span>
                    {/* Maybe required later */}
                    {/* <br /> */}
                    {/* <small>{incl.description}</small> */}
                  </li>
                ))}
              {preBookResult?.vehicle_charges.map((charge, idx) => (
                <li key={idx}>{charge.description}</li>
              ))}
              {preBookResult?.fees.map((fee, idx) => (
                <li key={idx}>{fee.description}</li>
              ))}
            </ul>
          </div>
          <div className={classes.extraInfo}>
            <h5>Terms & Conditions</h5>
            <InlineIcon
              icon="mdi:alert-circle"
              className={classes.extraInfoIcon}
            />
            <ul>
              <li>
                {`${t("toViewOfferPDF")}, `}
                <a
                  className={classes.anchorLink}
                  href={preBookResult?.product_information}
                  target="_blank"
                  rel="noreferrer">
                  {t("clickHere")}
                </a>
              </li>
              <li>
                {`${t("toViewTermsAndCondPDF")}, `}
                <a
                  className={classes.anchorLink}
                  href={preBookResult?.terms_conditions}
                  target="_blank"
                  rel="noreferrer">
                  {t("clickHere")}
                </a>
              </li>
              <li>
                Click the link to view the policy terms of the Full Protection
                Insurance{" "}
                <a
                  className={classes.anchorLink}
                  href={preBookResult?.insurance_content ?? ""}
                  target="_blank"
                  rel="noreferrer">
                  {t("clickHere")}
                </a>
              </li>
              <hr />
              {preBookResult.payment_rules.map((rule, idx) => (
                <li key={idx}>{rule?.description}</li>
              ))}
              {extraInfo.map((info, idx) => (
                <li key={idx}>{info?.description}</li>
              ))}
            </ul>
          </div>
          <CustomCheckbox
            id="termsAndConditionsCarRentalCheckBox"
            label={t("iHaveReadAgreeWithAbove")}
            checked={agreed}
            setChecked={setAgreed}
          />
        </React.Fragment>
      )}
    </div>
  );
};
Prebook.defaultProps = {
  loading: true,
  preBookResult: {},
};
Prebook.propTypes = {
  loading: PropTypes.bool.isRequired,
  preBookResult: PropTypes.object.isRequired,
  agreed: PropTypes.bool.isRequired,
  setAgreed: PropTypes.func.isRequired,
};
export default Prebook;
